<template>
  <div class="detail_content">
    <div class="detail_label">
      {{titleLabel}}
      <div v-if='!notRequiredFlag' class='require_items_label'>
        {{requiredItemLabel}}
      </div>
      <div class="cannotChanged_Label">
        ※
      </div>
    </div>
    <input class='detail_input_field' type="text" @input="inputUpdate">
  </div>
</template>

<script>
export default {
  props: {
    titleLabel: String,
    notRequiredFlag: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
    requiredItemLabel () {
      return this.$store.state.error.requiredItemLabel
    }
  },
  methods: {
    inputUpdate (e) {
      this.$emit('inputUpdate', e)
    }
  }
}
</script>
<style scoped>
.detail_input_field {
  width: calc(100% - 60px);
}
.cannotChanged_Label {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/inputCannotChangedSection.vue